import * as React from 'react'
import { ParsedUrlQuery } from 'querystring'

export const pageFromQuery = (query: ParsedUrlQuery) => {
  const limit = query.limit ? parseInt(query.limit.toString(), 10) : 20
  const offset = query.offset ? parseInt(query.offset.toString(), 10) : 0
  return { limit, offset }
}

export const pageToOffset = (page: number, pageCount: number = 10) => {
  return (page - 1) * pageCount
}

export const usePageChange = (params: {
  page: number
  onChange: (n: number) => Promise<void>
  afterChange?: (n?: number) => any
  dispatchOnMount?: boolean
}) => {
  const [mounted, setMounted] = React.useState(false)
  const [isPaging, setIsPaging] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  React.useEffect(() => {
    const fn = async () => {
      if (!params.dispatchOnMount && !mounted) {
        return
      }

      setIsPaging(true)
      await params.onChange(params.page)
      setIsPaging(false)

      if (mounted) {
        params.afterChange && params.afterChange(params.page)
      }
    }
    fn()
  }, [params.page])

  return { isPaging }
}

export const scrollToRef = (params: {
  ref: React.RefObject<any>
  offset?: number
}) => {
  const elm = params.ref?.current
  const offset = params.offset || 0

  if (elm) {
    const top = elm.getBoundingClientRect()?.top + window.scrollY - offset
    window.scroll({ top, behavior: 'smooth' })
  }
}

export const scrollToId = (id: string, options?: { offset: number }) => {
  const elm = document.getElementById(id)
  if (elm) {
    window.scroll({
      top:
        elm.getBoundingClientRect()?.top +
        window.scrollY -
        (options?.offset ?? 0),
      behavior: 'smooth',
    })
  }
}
